import { useCallback, useMemo } from 'react';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import { DraggableResourceTypes } from './Dispatch';
import './EquipmentAssignmentModal.scss';

const EMPTY_ARRAY = [];

const renderStaffOption = (staff) => {
    const groupInfo = staff.groups && staff.groups.length > 0
        ? ` (${staff.groups.map((g) => g.groupName).join(', ')})`
        : '';

    return `${staff.name}${groupInfo}`;
};

const renderEquipmentOption = (equip) => {
    const typeInfo = equip.equipmentType
        ? ` (${equip.equipmentType.description})`
        : '';
    return `${equip.description}${typeInfo}`;
};

const renderResourceOption = (resource) => {
    if (resource.name) {
        return renderStaffOption(resource);
    }

    return renderEquipmentOption(resource);
};

const resourceTypeOptions = [
    { value: DraggableResourceTypes.Staff, label: 'Staff' },
    { value: DraggableResourceTypes.Equipment, label: 'Equipment' },
];

export const EquipmentAssignmentModal = ({
    values,
    setFieldValue,
    resources = EMPTY_ARRAY,
    equipment,
    eligibleStaff = EMPTY_ARRAY,
    eligibleEquipment = EMPTY_ARRAY,
}) => {
    const showResourceTypeSelector = eligibleStaff.length > 0 && eligibleEquipment.length > 0;

    const currentResources = useMemo(() => {
        if (showResourceTypeSelector) {
            if (values.resourceTypeSelection === DraggableResourceTypes.Staff) {
                return eligibleStaff;
            }

            if (values.resourceTypeSelection === DraggableResourceTypes.Equipment) {
                return eligibleEquipment;
            }

            return [];
        }

        return resources;
    }, [showResourceTypeSelector, values.resourceTypeSelection, eligibleStaff, eligibleEquipment, resources]);

    const handleResourceTypeChange = useCallback(() => {
        setFieldValue({ target: { name: 'selectedId', value: null } });
    }, [setFieldValue]);

    return (
        <>
            <div className="equipment-info mb-3">
                <p className="mb-1">
                    <strong>Equipment:</strong>
                </p>

                <p className="equipment-description">
                    {equipment.description}
                    {equipment.equipmentType && (
                        <span className="text-muted">
                            {' '}
                            ({equipment.equipmentType.description})
                        </span>
                    )}
                </p>
            </div>

            {showResourceTypeSelector && (
                <ValidatedSelect
                    id="resourceTypeSelection"
                    name="resourceTypeSelection"
                    label="Type of resource"
                    options={resourceTypeOptions}
                    onChange={handleResourceTypeChange}
                    required
                    error="You must select a type of resource to assign to"
                />
            )}

            {(!showResourceTypeSelector || values.resourceTypeSelection) && (
                <ValidatedSelect
                    id="selectedId"
                    name="selectedId"
                    label="Assign to"
                    required
                    options={currentResources}
                    valueField="id"
                    error="A selection is required."
                    getOptionLabel={renderResourceOption}
                    getOptionValue={(option) => option.id}
                />
            )}
        </>
    );
};
